import { computed } from '@vue/composition-api';
export const useAuthorized = () => {
    return computed(() => !!globalThis?.$store?.state?.authentication?.accessToken || false);
};
